import React from "react";
import {Checkbox, Form, Input, Divider } from 'antd';

const { Item: FormItem } = Form;

/**
 * A form to search for another resource. It has two fields, name and sso, in order to search for a user.
 */
 class FindResourceForm extends React.Component {
    formRef = React.createRef();

    state = {
        confirmDirty: false,
        autoCompleteResult: [],
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                console.log('Received values of form: ', values);
            }
        });
    }

    handleConfirmBlur = (e) => {
        const value = e.target.value;
        this.setState({confirmDirty: this.state.confirmDirty || !!value});
    }

    render() {
        //const {getFieldDecorator} = this.props.form;
        const { isValid, findResourceFields, handleSearchFieldChange, handleSearch } = this.props;

        const formItemLayout = {
            labelCol: {
                xs: {span: 24},
                sm: {span: 24},
            },
            wrapperCol: {
                xs: {span: 24},
                sm: {span: 24},
            },
        };

        return (
            <Form ref={this.formRef} onSubmit={this.handleSubmit} {...formItemLayout}>
                <Divider />
                <Form.Item labelAlign="left" label="Search for a Resource By Name OR SSO" name="advice"/>
                {
                    !isValid ?
                    <Form.Item style={{color: 'red'}} labelAlign="left" label="Please enter a value in at least one field" />
                    : null
                }
                <Form.Item  name="name">
                    <Input
                      value={findResourceFields.name}
                      onChange={handleSearchFieldChange}
                      size={'large'}
                      placeholder={'Resource name'}/>
                </Form.Item>
                <Form.Item name="sso">
                    <Input
                      value={findResourceFields.sso}
                      onChange={handleSearchFieldChange}
                      size={'large'}
                      placeholder={'SSO'}/>
                </Form.Item>
                <Form.Item name="withDisabled">
                    <Checkbox
                      checked={findResourceFields.withDisabled}
                      onChange={handleSearchFieldChange}
                      size={'large'}
                      placeholder={'Inactive Resources'}>
                          Inactive Resources
                    </Checkbox>
                </Form.Item>
                 <Divider />
            </Form>
        );
    }
}

export default FindResourceForm;
